import {createAction} from '@reduxjs/toolkit'

export const openOfferCheckModal = createAction('offerCheckLoading/openModal')
export const closeOfferCheckModal = createAction('offerCheckLoading/closeModal')

export type ActionType =
  | ReturnType<typeof openOfferCheckModal>
  | ReturnType<typeof closeOfferCheckModal>
